import { render } from "./brand-modal.vue?vue&type=template&id=65ce6b6b"
import script from "./brand-modal.vue?vue&type=script&lang=js"
export * from "./brand-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__